const stepsbg = require('../../../shared/images/Referral-background.svg');

import React, {Component} from 'react';
import connectWithRouter from 'shared/components/redux/connectWithRouter';
import styles from '../AccountPageStyles';
import ReferralSteps from './ReferralSteps';
import _ from 'lodash';
import RaisedButton from 'material-ui/RaisedButton';
import * as Colors from 'material-ui/styles/colors';
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';
import Clipboard from 'clipboard-js';
import platform from 'platform';
import ReadOnlyTextField from 'crazyEditor/components/EditorUI/BaseUI/ReadOnlyTextField/ReadOnlyTextField';
import SvgIcon from 'material-ui/SvgIcon';
import ChipInput from 'shared/vendor/material-ui-chip-input/src/ChipInput';
import validator from 'validator';
import {telegram, gift, multipleCash, envelope, check} from 'shared/icons';
import {Referrals as ReferralsData} from '../AccountPageSectionsData';
import {HoverMixin} from 'shared/helpers/mixins';
import {sendInvitationEmail} from 'MyAccount/ViewDesigns/helpers/preferencesHelper';
import LinearProgress from 'material-ui/LinearProgress';
import {eventOnFirstTime} from 'shared/helpers/analyticsHelper';

const WAITING = 1;
const SENDING = 2;
const SENT = 3;

const COPYING = 4;

@connectWithRouter(
  state => ({
    userCredit: state.user.referrals.userCredit,
    userReferrals: state.user.referrals.userReferrals || [],
    referralsAmount: state.user.referrals.referralsAmount,
    totalCreditEarned: state.user.referrals.totalCreditEarned,
    personalInvite: state.user.referrals.personalInvite,
    referralProgram: state.user.referrals.referralProgram,
    userName: state.user.name,
  }),
  {}
)
export class Referrals extends Component {
  constructor(props) {
    super(props);
    this.state = {
      emails: [],
      hovered: false,
      sending: WAITING,
      copying: WAITING,
    };
  }

  componentDidMount() {
    eventOnFirstTime(`Referrals First Time`);
    this.emailsInputFocus();
  }

  getSendButtonText = sending => {
    switch (sending) {
      case SENDING:
        return 'sending...';
      case SENT:
        return 'Invitation Sent';
      case WAITING:
        return 'invite friends';
      default:
        break;
    }
  };

  emailsInputFocus() {
    if (this.refs.emails) {
      this.refs.emails.focus();
    }
  }

  linkClicked = () => {
    this.refs.invite.select();
  };

  copyToClipboardSupported = () => {
    const version = platform.version;
    return platform.name !== 'Safari';
  };

  isValid = email => {
    return validator.isEmail(email, {allow_utf8_local_part: false});
  };

  handleInvite = () =>
    _.defer(() => {
      const {emails} = this.state;
      if (_.isEmpty(emails)) {
        return;
      }
      const {referralProgram, personalInvite, userName} = this.props;
      const validEmails = [];
      _.forEach(emails, email => {
        if (this.isValid(email)) {
          validEmails.push(email);
        }
      });
      this.setState({
        sending: SENDING,
      });
      const sendingData = {
        personalInviteLink: personalInvite,
        emails: validEmails,
        referrerGrant: referralProgram.referrerRewardAmount,
        refereeGrant: referralProgram.refereeRewardAmount,
        reason: referralProgram.rewardQualification,
        referrerName: userName,
      };
      _.set(this, 'refs.emails.state.inputValue', '');
      sendInvitationEmail(sendingData).always(() => {
        this.setState({
          sending: SENT,
        });
        window.setTimeout(() => {
          this.setState({
            emails: [],
            sending: WAITING,
          });
        }, 3 * 1000);
      });
    });

  copyToClipboard = () => {
    const {personalInvite} = this.props;
    if (this.copyToClipboardSupported()) {
      window.analytics.track('Copy Invite Link Clicked');
      Clipboard.copy(personalInvite);
      this.setState({
        copying: COPYING,
      });
      window.setTimeout(() => {
        this.setState({
          copying: WAITING,
        });
      }, 3 * 1000);
    }
  };

  render() {
    const {userCredit, referralProgram, totalCreditEarned, userReferrals, referralsAmount, personalInvite} = this.props;
    const {emails, hovered, sending, copying} = this.state;
    const USERSTATS = [
      {text: 'Total Credit Earned', value: 'US $' + totalCreditEarned, color: Colors.orange800},
      {text: 'Credit Available', value: 'US $' + userCredit, color: Colors.grey700},
      {text: 'Friends Referred', value: referralsAmount, color: Colors.grey700},
    ];
    const STEPS = [
      {text: 'Send out invitations <br/> to your friends', iconSvgPath: telegram},
      {text: 'Each friend gets US $' + referralProgram.refereeRewardAmount, iconSvgPath: gift},
      {text: referralProgram.referralsText3, iconSvgPath: multipleCash},
    ];

    return (
      <div
        style={{
          ...styles.pageContentContainer,
          maxWidth: 720,
        }}
      >
        <div style={styles.h1}>{referralProgram.referralsText1}</div>
        <span>{referralProgram.referralsText2}</span>
        <div
          style={{
            backgroundImage: 'url(' + stepsbg + ')',
            display: 'flex',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            flexDirection: 'row',
            justifyContent: 'space-around',
            marginTop: 20,
            marginBottom: 30,
            maxHeight: 200,
            maxWidth: 720,
          }}
        >
          {_.map(STEPS, (step, index) => {
            return (
              <ReferralSteps
                iconSvgPath={step.iconSvgPath}
                key={index}
                numberSvgPath={step.numberSvgPath}
                text={step.text}
                number={index + 1}
              />
            );
          })}
        </div>
        <span>Share your personal link: </span>
        <div
          onMouseEnter={HoverMixin.onMouseEnter.bind(this)}
          onMouseLeave={HoverMixin.onMouseLeave.bind(this)}
          style={{
            display: 'flex',
            position: 'relative',
            justifyContent: 'space-between',
            borderStyle: 'dashed',
            borderWidth: 1,
            borderColor: Colors.grey300,
            marginTop: 10,
            marginBottom: 10,
          }}
        >
          <ReadOnlyTextField
            id="personalInviteLinkField"
            onClick={this.linkClicked}
            style={{
              fontSize: 20,
              color: Colors.grey700,
              margin: '0px 15px 0px 15px',
              width: '100%',
              zIndex: hovered ? 0 : 1,
            }}
            value={personalInvite}
            floatingLabelText=""
            ref="invite"
            underlineStyle={{display: 'none'}}
          />
          {this.copyToClipboardSupported() && (
            <RaisedButton
              style={{
                color: Colors.white,
                width: 120,
                opacity: hovered || copying !== WAITING ? 1 : 0,
                position: 'absolute',
                right: 5,
                top: '50%',
                transform: 'translateY(-50%)',
                zIndex: hovered ? 1 : 0,
              }}
              label={copying === WAITING ? 'copy link' : 'link copied'}
              onClick={this.copyToClipboard}
            />
          )}
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-around',
            flexDirection: 'row',
            flexWrap: 'wrap',
          }}
        >
          <ChipInput
            style={{
              width: '100%',
            }}
            floatingLabelText="Email Addresses"
            hintText="Insert Email Addresses"
            ref="emails"
            onRequestAdd={chip => {
              this.setState({emails: [...emails, chip]});
            }}
            onRequestDelete={chip => {
              this.setState({emails: emails.filter(c => c !== chip)});
            }}
            value={emails}
            newChipKeyCodes={[13, 188, 186, 32]}
          />
          <RaisedButton
            disabled={sending === SENDING}
            label={this.getSendButtonText(sending)}
            primary
            onClick={this.handleInvite}
            icon={
              <SvgIcon width="24" height="24" viewBox="0 0 24 24">
                <path fill="#fff" d={sending === SENT ? check : envelope} />
              </SvgIcon>
            }
            style={{
              width: '35%',
            }}
          >
            {sending === SENDING && (
              <LinearProgress
                mode="indeterminate"
                style={{position: 'absolute', bottom: 0, left: 0, width: '100%', backgroundColor: 'none'}}
              />
            )}
          </RaisedButton>
        </div>
        <div style={{...styles.h1, marginTop: 30}}>Referral Stats</div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            maxWidth: 740,
            justifyContent: 'space-between',
            margin: '20px 0px 20px 0px',
          }}
        >
          {_.map(USERSTATS, (userStat, index) => {
            return (
              <div
                key={index}
                style={{
                  marginLeft: index === 0 ? 0 : 10,
                  marginRight: index === USERSTATS.length - 1 ? 0 : 10,
                  display: 'flex',
                  backgroundColor: Colors.grey100,
                  height: 150,
                  width: 200,
                  flexGrow: 1,
                  flexDirection: 'column',
                  color: userStat.color,
                  justifyContent: 'center',
                  textAlign: 'center',
                }}
              >
                <div>
                  <div
                    style={{
                      fontSize: 50,
                    }}
                  >
                    {userStat.value}
                  </div>
                  <div
                    style={{
                      fontSize: 16,
                      fontWeight: 500,
                    }}
                  >
                    {userStat.text}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        {!!userReferrals.length && (
          <Table displaySelectAll={false} selectable={false} adjustForCheckbox={false}>
            <TableHeader
              style={{
                backgroundColor: Colors.grey200,
              }}
              displaySelectAll={false}
              adjustForCheckbox={false}
            >
              <TableRow
                style={{
                  height: 45,
                  textAlign: 'center',
                }}
              >
                <TableHeaderColumn>Friend</TableHeaderColumn>
                <TableHeaderColumn>Status</TableHeaderColumn>
                <TableHeaderColumn>Date</TableHeaderColumn>
              </TableRow>
            </TableHeader>
            <TableBody showRowHover displayRowCheckbox={false}>
              {_.map(userReferrals, referral => {
                return (
                  <TableRow
                    style={{
                      fontSize: 14,
                      height: 35,
                    }}
                  >
                    <TableRowColumn>{_.get(referral, 'refereeEmail')}</TableRowColumn>
                    <TableRowColumn>{_.get(referral, 'referralStatus')}</TableRowColumn>
                    <TableRowColumn>
                      {new Date(1000 * parseInt(_.get(referral, 'lastReferralUpdateDate'), 10)).toLocaleDateString()}
                    </TableRowColumn>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        )}
      </div>
    );
  }
}

export default _.assign(Referrals, ReferralsData);
